<template>
	<ListItem :title="title" class="cursor-pointer" @click.stop="toggleSelection">
		<div class="flex items-center gap-5">
			<p class="text-true-aareii-700 dark:text-true-aareii-300 text-2xl font-black">{{ votePercentage }}%</p>
			<p class="text-gray-600 dark:text-gray-400"><span class="text-lg font-bold">{{ numberOfVotes }}</span> / {{ election.votes.length }}</p>
			<i v-if="isSelected" class="fa-solid fa-circle-check text-green-700 text-2xl"/>
			<i v-else class="fa-solid fa-circle-xmark text-red-700 text-2xl"/>
		</div>
	</ListItem>
</template>
<script setup lang="ts">
import ListItem from '@/Components/UI/Lists/ListItem.vue'
import {type Election} from '@/Types/Elections/Election'
import {type ElectionCandidate} from '@/Types/Elections/ElectionCandidate'
import {ref, type Ref, defineProps, type ComputedRef, computed} from 'vue'

const props = defineProps<{
	title:string,
	limit?:number,
	selected:Array<number>,
	election:Election<any>,
	candidate:ElectionCandidate<Election<any>, any>,
}>()

const limit:Ref<number> = ref(props.limit ?? 1)
const selected:Ref<Array<number>> = ref(props.selected)
const election:Ref<Election<any>> = ref(props.election)
const candidate:Ref<ElectionCandidate<Election<any>, any>> = ref(props.candidate)

const numberOfVotes:ComputedRef<number> = computed(():number => {
	return election.value.votes.filter((v) => {
		return v.vote_type === candidate.value.candidate_type && v.vote_id === candidate.value.candidate_id
	}).length
})

const votePercentage:ComputedRef<string> = computed(():string => {
	return (election.value.votes.length ? (numberOfVotes.value / election.value.votes.length * 100) : 0).toFixed(2)
})

const isSelected:ComputedRef<boolean> = computed(():boolean => {
	return selected.value.includes(candidate.value.id)
})

function toggleSelection():void{
	if(election.value.open){
		const index = selected.value.findIndex((a:number) => a === candidate.value.id)
		if(index === -1){
			if(selected.value.length < limit.value){
				selected.value.push(candidate.value.id)
			}
		} else {
			selected.value.splice(index, 1)
		}
	}
}
</script>